export default __webpack_public_path__ + "static/media/2.7c39c258.jpg";